module.exports = __webpack_public_path__ + "static/img/jiceng1.339e70c2.png";